export enum NdfHorizon {
  _1MO,
  FirstFuture,
}

export namespace NdfHorizon {
  let elements = [NdfHorizon._1MO, NdfHorizon.FirstFuture];
  let alias = "com.bcdfx.model.NdfHorizon";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
